import axios from "axios";
import config from "../config";


const MAPBOX_KEY = config.MAPBOX_KEY;

export const getCordinates = async (address: string) => {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?access_token=${MAPBOX_KEY}`;

  const { data: response } = await axios.get(url);

  const latLng = response?.features[0]?.center;

  if (latLng && Array.isArray(latLng) && latLng[1]) {
    return {
      latitude: latLng[1],
      longitude: latLng[0]
    }
  }

  return;
}

export const getAddress = async (cordinates: iCordinates) => {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${cordinates.longitude},${cordinates.latitude}.json?country=br&language=pt-br&types=address&access_token=${MAPBOX_KEY}`;

  const { data: response } = await axios.get(url);

  return response;
}

interface iCordinates {
  latitude: number,
  longitude: number,
}
